import NameIcon from '../shared/NameIcon'
import type { ContactJson } from 'app/types/entities'
import { sanitizeName } from 'app/sanitize-name'
import { lastNameInitial } from 'lib/nameUtils'

const EMPTY_STYLE: Record<string, string | number> = {}

export function ContactNameIcon({
  contact,
  heightClassName = `h-12`,
  widthClassName = `w-12`,
  textClassName,
  isTiny = false,
  sizeStyle = EMPTY_STYLE,
  singleInitial = false,
  borderClassName,
  backgroundClassName,
}: {
  contact?: ContactJson
  heightClassName?: string
  widthClassName?: string
  textClassName?: string
  isTiny?: boolean
  sizeStyle?: Record<string, string | number>
  singleInitial?: boolean
  borderClassName?: string
  backgroundClassName?: string
}) {
  const cleanName = sanitizeName(contact?.name)
  let name =
    isTiny || singleInitial
      ? cleanName?.[0]
      : `${cleanName?.[0]}${lastNameInitial(cleanName || ` `)?.toLocaleUpperCase()}`
  name = name?.replace(/undefined/gi, ``)
  return (
    <NameIcon
      fullName={name}
      heightClassName={heightClassName}
      widthClassName={widthClassName}
      borderClassName={borderClassName}
      backgroundClassName={backgroundClassName}
      isTiny={isTiny}
      sizeStyle={sizeStyle}
      textClassName={textClassName}
    />
  )
}
